import type { Casino } from "@/lib/types";

export function LicenseLine({ casino }: { casino: Casino }) {
  if (!casino.operator_name || !casino.license_authority || !casino.license_number) return null;
  return <p className="mt-2 text-xs">{casino.operator_name} · {casino.license_authority} · {casino.license_number}</p>;
}
